jQuery(document).ready(function() {
	jQuery('.wp-block-ic-blocks-parallax').each(function () {
		let parallaxWrapper = jQuery(this);
		let mobileHeight = parallaxWrapper.data('mobile-height');
		let desktopHeight = parallaxWrapper.css('height');
		jQuery(window).scroll(function(){
			checkParallax(parallaxWrapper);
		});
		jQuery(window).resize(function(){
			if(jQuery(window).width()>782){
				parallaxWrapper.css('min-height', desktopHeight);
				parallaxWrapper.find('.ic-blocks-parallax-container').css('min-height', desktopHeight);
			}else{
				parallaxWrapper.css('min-height', mobileHeight);
				parallaxWrapper.find('.ic-blocks-parallax-container').css('min-height', mobileHeight);
			}
			checkParallax(parallaxWrapper);
		})
		checkParallax(parallaxWrapper);
	});
})

function checkParallax(parallaxWrapper){

	let parallaxStrenght = parseFloat('0.'+parallaxWrapper.data("parallax-strenght"));
	let parallaxSpeed = 1+parallaxStrenght;
	let parallaxH = parallaxWrapper.height();
	let parallaxY = parallaxWrapper.offset().top;
	let windowH = jQuery(window).height();
	let windowY = jQuery(window).scrollTop();

	let percentViewed = (parallaxY+parallaxH)-windowY;
	percentViewed = percentViewed/(windowH+parallaxH);
	percentViewed *=100;
	if(percentViewed<=0) percentViewed=0;
	if(percentViewed>=100) percentViewed=100;
	parallaxWrapper.find('.ic-blocks-parallax-figure img')
		.css('top', (percentViewed*parallaxSpeed)+'%')
		.css('transform', 'translate(-50%,-'+(percentViewed)+'%) scale('+parallaxSpeed+')')

}
